<div *ngIf="showSearchBar || showColumnRenderer" class="row margin-standard">
	<div class="col-7">
		<div *ngIf="showSearchBar" class="asset-search">
			<input type="text" class="search-input" placeholder="Search for a fund" [formControl]="searchFormControl" /><icon type="search" class="icon"></icon>
		</div>
	</div>
	<div class="col-10"></div>
	<div class="col-7 text-align-right">
		<!-- <ac-select-columns
			*ngIf="showColumnRenderer"
			[columnsObject]="columnsObject"
			(onColumnsChange)="changeColumns($event)"
			(onColumnsObjectChange)="setColumnObject($event)"
		></ac-select-columns> -->
	</div>
</div>
<div class="table-group-container" #tableContainer>
	<div class="table-container left-table">
		<cdk-table #staticTableHeader class="static-table" [dataSource]="dataOnPage$" multiTemplateDataRows>
			<ng-container *ngFor="let column of displayedColumns; let index = index">
				<ng-container cdkColumnDef="{{ column }}">
					<cdk-header-cell
						*cdkHeaderCellDef
						(click)="adjustSort(column)"
						[ngClass]="[dataArray[0][column].config.label.attributes.columnAlignment, dataArray[0][column].config.label.attributes.className, 'text-bold']"
						[class.ac-sticky-header]="stickyColumnIndex.includes(index)"
						[class.last-sticky-column]="index === stickyColumnIndex[stickyColumnIndex.length - 1]"
						[ngStyle]="{ visibility: !stickyColumnIndex.includes(index) ? 'hidden' : null }"
					>
						<div class="th-inner-wrapper">
							<span>{{ column }}</span>
							<icon
								*ngIf="showInfoBubble && infoBubbleMappings[column]"
								type="info-circle"
								class="info-circle text-14 color-primary"
								[tooltip]="infoBubble"
								[analytic-data]="{ linkName: 'tooltip_' + dataArray[0][column].config.label }"
							></icon>
							<ng-template #infoBubble> <section [innerHTML]="infoBubbleMappings[column]"></section> </ng-template>
							<ng-container *ngIf="isSortable">
								<icon type="sort" *ngIf="sortKey$.value !== column" class="sort-icon"></icon>
								<icon type="sort-asc" *ngIf="sortKey$.value === column && sortDirection$.value === 1" class="sort-icon"></icon>
								<icon type="sort-desc" *ngIf="sortKey$.value === column && sortDirection$.value === -1" class="sort-icon"></icon>
							</ng-container>
						</div>
					</cdk-header-cell>
				</ng-container>
			</ng-container>
			<cdk-header-row *cdkHeaderRowDef="displayedColumns"></cdk-header-row>
		</cdk-table>

		<cdk-table #verticalScrollingTable class="static-table" [dataSource]="dataOnPage$" multiTemplateDataRows>
			<ng-container *ngFor="let column of displayedColumns; let index = index">
				<ng-container cdkColumnDef="{{ column }}">
					<cdk-cell
						*cdkCellDef="let element"
						[ngClass]="[
							element[column].config.label.attributes.className,
							element[column].config.label.attributes.columnAlignment ? element[column].config.label.attributes.columnAlignment : 'text-align-center'
						]"
						[style.background-color]="element[column] && element[column].attribute ? element[column].attribute.backgroundColor : null"
						[class.color-cell]="element[column] && element[column].attribute && element[column].attribute.backgroundColor"
						[class.sticky-cell]="stickyColumnIndex.includes(index)"
						[class.last-sticky-column]="index === stickyColumnIndex[stickyColumnIndex.length - 1]"
						[ngStyle]="{ visibility: !stickyColumnIndex.includes(index) ? 'hidden' : null }"
					>
						<ac-table-cell [data]="element[column]"></ac-table-cell>
					</cdk-cell>
				</ng-container>
			</ng-container>

			<!-- this expand row feature is not fully implemented, will do it later to take in child component -->
			<ng-container cdkColumnDef="expandedDetail">
				<cdk-cell *cdkCellDef="let element" [attr.colspan]="displayedColumns.length">
					<div class="element-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'"><div class="element-diagram">test</div></div>
				</cdk-cell>
			</ng-container>

			<cdk-row
				*cdkRowDef="let element; columns: displayedColumns"
				class="element-row"
				[class.expanded-row]="expandedElement === element"
				(click)="expandRow(element)"
			></cdk-row>
			<cdk-row *cdkRowDef="let row; columns: ['expandedDetail']" class="detail-row"></cdk-row>
		</cdk-table>
	</div>
	<div class="table-container right-table">
		<cdk-table #horizontalScrollingTable class="static-table" [dataSource]="dataOnPage$" multiTemplateDataRows>
			<ng-container *ngFor="let column of displayedColumns; let index = index">
				<ng-container cdkColumnDef="{{ column }}">
					<cdk-header-cell
						*cdkHeaderCellDef
						(click)="adjustSort(column)"
						[ngClass]="[
							dataArray[0][column].config.label.attributes.columnAlignment ? dataArray[0][column].config.label.attributes.columnAlignment : '',
							dataArray[0][column].config.label.attributes.className ? dataArray[0][column].config.label.attributes.className : '',
							dataArray[0][column].config.label.attributes.borderClassName ? dataArray[0][column].config.label.attributes.borderClassName : '',
							'text-bold'
						]"
						[class.ac-sticky-header]="stickyColumnIndex.includes(index)"
						[class.last-sticky-column]="index === stickyColumnIndex[stickyColumnIndex.length - 1]"
						[ngStyle]="{ visibility: stickyColumnIndex.includes(index) ? 'hidden' : null }"
					>
						<div class="th-inner-wrapper">
							<span>{{ column }}</span>
							<!-- Info bubble -->
							<icon
								*ngIf="showInfoBubble && infoBubbleMappings[column] && dataArray[0][column].config.id !== 'iSharesIdeas'"
								type="info-circle"
								class="info-circle text-14 color-primary"
								[tooltip]="infoBubble"
								[analytic-data]="{ linkName: 'tooltip_' + dataArray[0][column].config.label }"
							></icon>
							<ng-template #infoBubble>
								<section [innerHTML]="infoBubbleMappings[column]"></section>
							</ng-template>
							<!-- Info bubble for iShares Ideas column -->
							<icon
								*ngIf="showInfoBubble && infoBubbleMappings[column] && dataArray[0][column].config.id === 'iSharesIdeas'"
								type="info-circle"
								class="info-circle pointer"
								(click)="toggleInfoDialog(dataArray[0][column].config.label.key, infoBubbleMappings[column])"
							>
							</icon>
							<!-- Sorting -->
							<ng-container *ngIf="isSortable && dataArray[0][column].config.id !== 'iSharesIdeas'">
								<icon type="sort" *ngIf="sortKey$.value !== column" class="sort-icon"></icon>
								<icon type="sort-asc" *ngIf="sortKey$.value === column && sortDirection$.value === 1" class="sort-icon"></icon>
								<icon type="sort-desc" *ngIf="sortKey$.value === column && sortDirection$.value === -1" class="sort-icon"></icon>
							</ng-container>
						</div>
					</cdk-header-cell>
				</ng-container>
			</ng-container>
			<cdk-header-row *cdkHeaderRowDef="displayedColumns"></cdk-header-row>
		</cdk-table>
		<cdk-table #scrollingTable class="static-table" [dataSource]="dataOnPage$" multiTemplateDataRows>
			<ng-container *ngFor="let column of displayedColumns; let index = index">
				<ng-container cdkColumnDef="{{ column }}">
					<cdk-cell
						*cdkCellDef="let element"
						[ngClass]="[
							element[column].config.label.attributes.className ? element[column].config.label.attributes.className : '',
							element[column].config.label.attributes.borderClassName ? element[column].config.label.attributes.borderClassName : '',
							element[column].config.label.attributes.columnAlignment ? element[column].config.label.attributes.columnAlignment : 'text-align-center'
						]"
						[style.background-color]="element[column] && element[column].attribute ? element[column].attribute.backgroundColor : null"
						[class.color-cell]="element[column] && element[column].attribute && element[column].attribute.backgroundColor"
						[class.sticky-cell]="stickyColumnIndex.includes(index)"
						[class.last-sticky-column]="index === stickyColumnIndex[stickyColumnIndex.length - 1]"
						[ngStyle]="{ visibility: stickyColumnIndex.includes(index) ? 'hidden' : null }"
					>
						<ac-table-cell [data]="element[column]"></ac-table-cell>
					</cdk-cell>
				</ng-container>
			</ng-container>

			<!-- this expand row feature is not fully implemented, will do it later to take in child component -->
			<ng-container cdkColumnDef="expandedDetail">
				<cdk-cell *cdkCellDef="let element" [attr.colspan]="displayedColumns.length">
					<div class="element-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'"><div class="element-diagram">test</div></div>
				</cdk-cell>
			</ng-container>

			<cdk-row
				*cdkRowDef="let element; columns: displayedColumns"
				class="element-row"
				[class.expanded-row]="expandedElement === element"
				(click)="expandRow(element)"
			></cdk-row>
			<cdk-row *cdkRowDef="let row; columns: ['expandedDetail']" class="detail-row"></cdk-row>
		</cdk-table>
	</div>

	<div #dummyVerticalScrolling class="dummy-vertical-scroll-bar" (scroll)="updateScroll()">
		<div #dummyVerticalScrollingContent class="dummy-vertical-content"></div>
	</div>
	<div #dummyHorizontalScrolling class="dummy-horizontal-scroll-bar" (scroll)="updateScroll()">
		<div #dummyHorizontalScrollingContent class="dummy-horizontal-content"></div>
	</div>
</div>

<div class="row" *ngIf="showPagination">
	<div class="col-24">
		<ac-pagination
			[collectionSize]="tableDataSource$.value.length"
			[pageSize]="pageSize$.value"
			[page]="currentPage$.value"
			(pageChange)="currentPage$.next($event)"
			(pageSizeChange)="pageSize$.next($event)"
		>
		</ac-pagination>
	</div>
</div>

<!-- Modal to show info bubble info for iShares Ideas column -->
<bfa-modal width="750px" [enableBackdrop]="true" [enableClose]="true" [isVisible]="showiSharesIdeasInfoBubbleModal" (isVisibleChange)="showiSharesIdeasInfoBubbleModal = false">
	<section class="modal-message-container text-13" [innerHTML]="iSharesIdeasInfoBubbleText"></section>
</bfa-modal>
